import * as React from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { RelodeTheme } from "@relode/core";

const useContentStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                overflowY: "auto",
                flex: "1 1 auto",
                WebkitOverflowScrolling: "touch", // Add iOS momentum scrolling.
            },
        }),
    { name: "PageContent" }
);

export const PageContent = (props: { children: React.ReactNode }) => {
    const classes = useContentStyles({});

    return <div className={classes.root}>{props.children}</div>;
};
